import React from "react"
import PubSub from "pubsub-js"
import { PaymentElement } from "@stripe/react-stripe-js"
import usePaymentSubmission from "./use-payment-submission"
import PlatformAuth from "aldoo-ra/PlatformAuth"

const { useAuth } = PlatformAuth

const CheckoutForm = ({ store, isActive }) => {
  const { handleSubmit, ready, setReady, isReady, loading } = usePaymentSubmission(store)
  const [auth] = useAuth()

  const { hideCheckout, showCart, getFragment, purchaseUserEmail, tempAuthForPurchase } = store

  const CheckoutTotalBar = getFragment("checkout-total-bar")

  // Get email from auth, tempAuth, or purchaseUserEmail (in order of preference)
  const userEmail = auth?.email || tempAuthForPurchase?.email || purchaseUserEmail || ''

  const handleBackToInvoice = () => {
    PubSub.publish("PURCHASE_FLOW_BACK")
  }

  const handlePaymentSubmit = async () => {
    // Email is already set up in handleEmailVerification (before checkout)
    // Complete payment with stored invoice data
    await handleSubmit(store.invoiceData, userEmail)
  }

  // Update button state via PubSub - only when this step is active
  React.useEffect(() => {
    if (!isActive) {
      return
    }

    PubSub.publish("PURCHASE_FLOW_UPDATE_BUTTON", {
      stepId: 'payment',
      onContinue: handlePaymentSubmit,
      onBack: handleBackToInvoice,
      canContinue: isReady && !loading,
      loading: loading
    })
  }, [isReady, loading, isActive])

  return (
    <div className="h-full flex flex-col justify-between">
      <div className="pt-8 pb-[70px] px-2 md:px-6">
        <div className="mb-4">
          <PaymentElement
            onReady={() => setReady(true)}
            options={{
              defaultValues: {
                billingDetails: {
                  email: userEmail
                }
              }
            }}
          />
        </div>
      </div>

      {/* Invoice link + total - Sticky Bottom */}
      <CheckoutTotalBar store={store} />
    </div>
  )
}

export default CheckoutForm
